import AesImage from 'component/AesImage'
import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  padding: 0.62rem 0;
  position: relative;
  background: var(--component-area-swiper--background);
`

export const StyledAesImage = styled(AesImage).attrs({ aspectRatio: null })`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
`
